import cn from 'classnames';
import { ImageComponent } from 'components/Image';
import styles from 'pages/Users/UserCard/UserCard.scss';

export const UserCard = ({ role, user, countries, dancerClasses }) => {
  const countryName =
    typeof user?.country === 'object'
      ? user.country?.name
      : countries?.[user?.country] || user?.country;

  return (
    <li className={styles.card}>
      {user?.photo?.url || user?.avatar ? (
        <ImageComponent className={styles.photo} src={user?.photo?.url || user?.avatar} />
      ) : (
        <div className={cn(styles.photo, styles.placeholder)} />
      )}
      <div className={styles.cardInfo}>
        <h2 className={styles.name}>
          <span>{user?.name}</span>
          <span>{user?.surname}</span>
        </h2>
        {role === 'dancers' && user?.level && (
          <p className={styles.level}>{dancerClasses?.[user.level] || user.level} level</p>
        )}
        {countryName && (
          <p className={styles.country}>
            <img
              className={styles.flagIcon}
              src={`https://euro-dance.cdn.express/${countryName}.svg`}
              alt={countryName}
            />
            <span>{countryName}</span>
          </p>
        )}
      </div>
    </li>
  );
};
